import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'chartsFidelity',
    label: 'Group Member Fidelity',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
